export default {
  methods: {
    clientCode: function () {
      return window.location.href.split("//")[1].split(".")[0];
    },
    clientLogo: function () {
      return `https://agrotecchain.s3.amazonaws.com/images_logos/${this.clientCode()}.png`;
    },
    clientLogoError(e) {
      e.target.src = "https://agrotecchain.s3.amazonaws.com/images_logos/app.png";
    },
  },
};